import { render, staticRenderFns } from "./ownerName.vue?vue&type=template&id=f21267fc"
import script from "./ownerName.vue?vue&type=script&lang=js"
export * from "./ownerName.vue?vue&type=script&lang=js"
import style0 from "./ownerName.vue?vue&type=style&index=0&id=f21267fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports